module.exports = __webpack_public_path__ + "media/images/countrysquared/kn-976b2d8f966f992d4e629642d347cb9c.svg";